import * as actionTypes from "../types/Metamask";
import { BigNumber } from 'bignumber.js';
import { getAmount } from '../../utils/Utils';
import { EmptyDelegates } from "../../constants/Contracts";

const INITIAL_STATE = {
  networkId: '',
  provider: null,

  hasError: false,
  isConnecting: false,
  isConnected: false,
  isFetchingBalance: false,

  address: null,
  balance: 0,
  isDelegating: false,
  isDelegated: false,
  delegates: EmptyDelegates
};

export const metamaskReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_NETWORKID: {
      return Object.assign({}, state, {
        networkId: action.networkId
      });
    }
    case actionTypes.SET_PROVIDER: {
      return Object.assign({}, state, {
        provider: action.provider
      })
    }
    case actionTypes.SET_ADDRESS: {
      return Object.assign({}, state, {
        address: action.address,
        isConnecting: false,
        hasError: false
      })
    }
    case actionTypes.SET_ISCONNECTING: {
      return Object.assign({}, state, {
        isConnecting: action.isConnecting,
        hasError: false
      })
    }
    case actionTypes.SET_HASERROR: {
      return Object.assign({}, state, {
        hasError: action.hasError
      })
    }
    case actionTypes.FETCH_BALANCE_START: {
      return Object.assign({}, state, {
        isFetchingBalance: true
      })
    }
    case actionTypes.FETCH_BALANCE_END: {
      return Object.assign({}, state, {
        isFetchingBalance: false
      })
    }
    case actionTypes.FETCH_BALANCE_SUCCESS: {
      const balance = getAmount(new BigNumber(action.response.body), 18)
      return Object.assign({}, state, {
        isFetchingBalance: true,
        balance
      })
    }
    case actionTypes.SET_BALANCE: {
      return Object.assign({}, state, {
        balance: action.balance,
        isFetchingBalance: false
      })
    }
    case actionTypes.SET_ISFETCHINGBALANCE: {
      return Object.assign({}, state, {
        balance: 0,
        isFetchingBalance: true
      })
    }

    //DELEGATE 
    case actionTypes.DELEGATE_START: {
      return Object.assign({}, state, {
        isDelegating: true,
        errMsg: ""
      });
    }
    case actionTypes.DELEGATE_END: {
      return Object.assign({}, state, {
        isDelegating: false
      });
    }
    case actionTypes.DELEGATE_SUCCESS: {
      return Object.assign({}, state, {
        isDelegated: true,
      });
    }
    case actionTypes.DELEGATE_FAILURE: {
      return Object.assign({}, state, {
        errMsg: action.errMsg
      });
    }

    //FETCH DELEGATES
    case actionTypes.FETCH_DELEGATES_START: {
      return Object.assign({}, state, {
        isFetchingDelegates: true
      })
    }
    case actionTypes.FETCH_DELEGATES_END: {
      return Object.assign({}, state, {
        isFetchingDelegates: false
      })
    }
    case actionTypes.FETCH_DELEGATES_SUCCESS: {
      const delegates = action.response.body;
      return Object.assign({}, state, {
        isFetchingDelegates: true,
        delegates
      })
    }

    default: {
      return state
    }
  }
};
